<section
  class="mindmap-shell"
  [class.is-drawing-tools-visible]="drawingToolsVisible()"
  [class.is-focus-mode]="viewMode() === 'focus'"
>
  <div class="mindmap-card">
    <div
      class="mindmap-map"
      [class.is-focus-mode]="viewMode() === 'focus'"
      [attr.aria-busy]="isRefiningNodeWithAi()"
    >
      <lib-flash-map
        #flashMap
        data-testid="mindmap-editor"
        [mindData]="mindData()"
        [nodeMetrics]="nodeMetrics()"
        [options]="options()"
        [editable]="canUpdateMindMap"
        [theme]="flashMapVisualTheme()"
        [appearanceTheme]="flashMapAppearanceTheme()"
        [language]="flashMapLanguage()"
        (onShow)="handleMapShow()"
        (onEdit)="handleMapEdit($event)"
        (drawingChange)="handleDrawingChange($event)"
        (flashcardDeckClick)="handleFlashcardDeckClick($event)"
      />
      @if (viewMode() !== "focus" && shouldShowNodeActionPanel()) {
        @if (canUpdateMindMap) {
          <app-map-node-action-panel
            data-testid="mindmap-node-actions"
            [flashMap]="flashMap"
            [language]="flashMapLanguage()"
            [theme]="flashMapVisualTheme()"
            [layoutMode]="flashMapLayout()"
            [mindMapNotesBlocked]="mindMapNotesBlocked()"
            (mindMapNotesLimitClick)="showMindMapNotesLimitReached()"
            (associateDeckClick)="handleDeckAssociationClick($event)"
            (trainingModeClick)="handleFlashcardTrainingClick($event)"
            (refineNodeClick)="handleRefineNodeClick($event)"
            (imagePickerClick)="openNodeImagePicker($event)"
          />
        }
        <app-map-title-panel
          [flashMap]="flashMap"
          [mindMapId]="versionMindMapId"
          [workspaceId]="versionWorkspaceId"
          [mindMapExportBlocked]="mindMapExportBlocked()"
          [mindMapShareBlocked]="mindMapShareBlocked()"
          [mindMapInviteBlocked]="mindMapInviteBlocked()"
          [canCreateMindMap]="canCreateMindMap"
          [canUpdateMindMap]="canUpdateMindMap"
          [canDeleteMindMap]="canDeleteMindMap"
          [drawingToolsVisible]="drawingToolsVisible()"
          (menuAction)="onMenuAction($event)"
          (drawingToolsToggle)="onDrawingToolsToggle($event)"
          (mindMapExportLimitClick)="showMindMapExportLimitReached()"
          (mindMapShareLimitClick)="showMindMapShareLimitReached()"
          (mindMapInviteLimitClick)="showMindMapInviteLimitReached()"
          (versionRowClick)="handleVersionRowClick($event)"
          (versionMenuAction)="handleVersionMenuAction($event)"
        />
      }
      <app-map-zoom-panel
        [flashMap]="flashMap"
        (modeChange)="onZoomModeChange($event)"
      />
      <app-map-note-modal
        [flashMap]="flashMap"
        (noteDraftChanged)="handleNoteDraftChanged($event)"
        (noteFlushRequested)="handleNoteFlushRequested($event)"
      />
      @if (isRefiningNodeWithAi()) {
        <app-processing-loader appearance="overlay" />
      }
      @if (mindMapLoadState() === "loading") {
        <app-processing-loader appearance="overlay" />
      }
      @if (mindMapLoadState() === "error") {
        <div
          class="mindmap-load-state mindmap-load-state-error"
          role="alert"
          aria-live="assertive"
        >
          <p>{{ mindMapLoadError() }}</p>
          @if (requestedMindMapId) {
            <button
              type="button"
              class="btn btn-primary"
              (click)="retryMindMapLoad()"
            >
              {{ i18n.tr("retryLoadingMindMap") }}
            </button>
          }
        </div>
      }
    </div>
  </div>
</section>
